import request from '../utils/request.js'

export default {
	getData(params) {
		return request.post(`System/get_payconfig`, params).then(res => res.data);
	},
	edit(params) {
		return request.post(`System/save_payconfig`, params).then(res => res.data);
	},

    getBaseConfig(params) {
		return request.post(`System/get_baseconfig`, params).then(res => res.data);
	},
	editBaseConfig(params) {
		return request.post(`System/save_baseconfig`, params).then(res => res.data);
	},
    uploadImg(params) {
		return request.upload(`Index/uploads`, params).then(res => res.data);
	},
    getInfo(params) {
		return request.post(`System/get_info`, params).then(res => res.data);
	},

	// 日志管理相关接口
	getLogList(params) {
		return request.get(`System/get_logs`, {params}).then(res => res.data);
	},
	deleteLog(params) {
		return request.post(`System/delete_log`, params).then(res => res.data);
	},
	batchDeleteLogs(params) {
		return request.post(`System/batch_delete_logs`, params).then(res => res.data);
	},
	exportLogs(params) {
		return request.post(`System/export_logs`, params).then(res => res.data);
	},


}


// WEBPACK FOOTER //
// ./src/api/system.js